import { defineComponent } from 'vue'
import type { IncidentInfo } from '#models/incident_info'

export default defineComponent({
  props: {
    incident: {
      type: Object as () => IncidentInfo,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
})
